import React, { useEffect, useState } from "react";
import { Dropdown } from 'primereact/dropdown';

import performanceManagementService from "@services/performanceManagement.service";
import { Button } from 'primereact/button';
import strftime from "strftime";
import Chart from "@containers/PerformanceManagement/Chart";

export default function DashboardUMTS() {
    let kpi = [
        "RRC Setup Success Ratio",
        "RRC Congestion Ratio",
        "Availability",
        "CS RAB Setup Success Ratio",
        "PS RAB Setup Success Ratio (PCH)",
        "PS R99 RAB Setup Success Rate",
        "Soft Handover Success Ratio",
        "Intra-frequency Hard Handover Success Ratio",
        "Inter-frequency Hard Handover Success Ratio",
        "CS Service Drop Ratio",
        "PS Call Drop Ratio (PCH)",
        "Number of CS Users",
        "Number of HSDPA Users",
        "Number of HSUPA Users",
        "R99 Service DL Traffic Volume",
        "R99 Service UL Traffic Volume",
        "HSDPA Traffic Volume",
        "HSUPA Traffic Volume",
        "User HSDPA Throughput",
        "User HSUPA Throughput",
        "RTWP",
        "PING.MeanJITTER",
        "PING.MeanDELAY",
        "PING.MeanLOST",
    ];
    const [selectedCity, setSelectedCity] = useState(null);
    const [loading, setLoading] = useState(false);
    // TH1RNCH1
    // TH2RNCH2
    // TH1RNCH2
    // TH1RNCH5
    // TH2RNCH3
    // TH1RNCH3
    // TH1RNCH4
    // TH2RNCH1
    const cities = [
        { name: 'All', code: ['TH1RNCH1', 'TH2RNCH2', 'TH1RNCH2', 'TH1RNCH5', 'TH2RNCH3', 'TH1RNCH3', 'TH1RNCH4', 'TH2RNCH1'] },
        { name: 'TH1RNCH1', code: ['TH1RNCH1'] },
        { name: 'TH2RNCH2', code: ['TH2RNCH2'] },
        { name: 'TH1RNCH2', code: ['TH1RNCH2'] },
        { name: 'TH1RNCH5', code: ['TH1RNCH5'] },
        { name: 'TH2RNCH3', code: ['TH2RNCH3'] },
        { name: 'TH1RNCH3', code: ['TH1RNCH3'] },
        { name: 'TH1RNCH4', code: ['TH1RNCH4'] },
        { name: 'TH2RNCH1', code: ['TH2RNCH1'] },

    ];
    const [charts, setCharts] = useState([]);
    useEffect(() => {
        // console.log(selectedCity);
        setCharts([]);
        let isMounted = true;
        if (selectedCity) {

            let end = new Date();
            let start = new Date();
            start.setDate(start.getDate() - 30);
            const start_mini = strftime("%m-%d", start);
            const end_mini = strftime("%m-%d", end);
            const date_mini = start_mini + "|" + end_mini;
            let data = {
                "buket": "1h",
                "startDate": start,
                "endDate": end,
                "scope": "RNC",
                "ne_list": selectedCity.code,
                "kpi_id": kpi,
                "tech": "UMTS",

            }
            setLoading(true);
            performanceManagementService.fetchKpi2RbyName(data).then((response) => {
                setLoading(false)
                if (isMounted) {
                    // console.log("xxxx", response.data);

                    if (response.data) {
                        let charts_new = [];
                        for (const chart_data in response.data) {
                            charts_new.push(<div><Chart headerName={chart_data} data={response.data[chart_data]} ></Chart></div>);

                        }
                        setCharts(charts_new);
                    }
                    else {
                    }

                }

            }).catch((e) => {
                // toast.current.show({ severity: 'error', summary: 'Error Message', detail: 'Fech kpi faild' });
                console.log(e);
                setLoading(false);
            }

            );
        }

        return () => { isMounted = false };
    }, [selectedCity]);

    return (
        <div>
            <div className="grid grid-cols-2 gap-2 p-2">
                <Dropdown value={selectedCity} onChange={(e) => setSelectedCity(e.value)} options={cities} optionLabel="name"
                    placeholder="Select a RNC" className="w-full md:w-14rem" />
                <Button loading={loading} icon="pi pi-list" rounded text severity="info" aria-label="User" />
            </div>
            <div className="grid grid-cols-1 gap-2 p-2">
                {charts}
            </div>
        </div>
    )
}